// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { subscribeStyles } from "@conklin/Overrides/Widgets/Basic/Subscribe";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

subscribeStyles.mainGridContainer = {
    gap: 0,
};

subscribeStyles.titleLabel = {
    variant: "h6",
    forwardAs: "span",
    color: "common.white",
};

subscribeStyles.emailGridItem = {
    width: 12,
    css: css`
        position: relative;
        overflow: hidden;
    `,
};

subscribeStyles.emailTextField = {
    mergeCss: true,
    cssOverrides: {
        formInputWrapper: css`
            &&& input {
                padding-right: 110px; // 103px  button width + 9 input field padding: ;
            }
        `,
    },
};

subscribeStyles.emailButton = {
    sizeVariant: "small",
    css: css`
        position: absolute;
        right: 4px;
        top: 4px;
    `,
};

subscribeStyles.titleGridItem = {
    width: 12,
    css: css`
        justify-content: start;
    `,
};

subscribeStyles.descriptionGridItem = {
    width: 12,
    css: css`
        justify-content: start;
    `,
};

subscribeStyles.descriptionText = {
    color: "common.white",
    css: css`
        && {
            margin-bottom: 12px;
            ${TypographyStyle} {
                font-size: 12px;
                line-height: 20px;
                margin-bottom: 0;
            }
        }
    `,
};
